import { useMutation, useQueryClient } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';
export const useUpdateSubscriptionFrequencyAndQuantity = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      subscriptionId,
      frequency,
      quantity,
    }: {
      subscriptionId: number;
      frequency: number;
      quantity: number;
    }) => {
      return subscriptionService.updateSubscriptionFrequencyAndQuantity(
        subscriptionId,
        frequency,
        quantity
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Subscription successfully updated.']);
        queryClient.invalidateQueries([
          ServerStateKeysEnum.subscriptionHistory,
        ]);
      },
      onError: () => {
        displayNotification(
          i18n['Failed to update subscription frequency!'],
          'danger'
        );
      },
    }
  );
};
